<div *ngIf="bike && bike.id">
  <div class="page-background" [ngStyle]="{ 'background-image': 'url('+ bike.primaryImageURL +')' }"></div>

  <div class="center-container" style="margin-top: -48px">
    <div class="rows" *ngIf="partner && partner.partnerID">
      <div class="col-12">
        <div class="partner-name">{{partner.partner}}</div>
      </div>
    </div>
  </div>

  <div class="center-container-wide">
    <div class="rows" *ngIf="showNewBikeSaleBanner">
      <div class="col-12" style="padding-left: 0px;padding-right: 0px;">
        <div class="new-bike-banner">
          <div class="congrats">
            Congrats
          </div>
          <div class="on-your-new-ride">On your new ride</div>
        </div>
      </div>
    </div>
  </div>

  <div class="center-container" style="padding-bottom: 32px;">
    <div class="row">
      <div class="col-lg-6 col-xl-8 order-2 order-lg-1">
        <div class="image-container">
          <div class="primary-image">
            <div class="left-arrow" (click)="prevImage(bike.primaryImageURL)" *ngIf="bike.images.length > 1"><span
              class="fa fa-chevron-left"></span></div>
            <img [src]="bike.primaryImageURL"/>
            <div class="right-arrow" (click)="nextImage(bike.primaryImageURL)" *ngIf="bike.images.length > 1"><span
              class="fa fa-chevron-right"></span></div>
          </div>

          <div style="display: flex;">
            <div class="image-list" *ngIf="bike.images.length > 1">
              <div *ngFor="let image of bike.images">
                <img [src]="image.mediaThumbURL" (click)="bike.primaryImageURL = image.mediaURL"/>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="image-list-small" *ngIf="bike.images.length > 1">
          <div *ngFor="let image of bike.images">
            <img [src]="image.mediaThumbURL" (click)="bike.primaryImageURL = image.mediaURL" />
          </div>
        </div> -->
      </div>
      <div class="col-lg-6 col-xl-4 order-1 order-lg-2">
        <div class="bike-detail-container bike-content-container">
          <div class="manufacturer-logo"><img [src]="bike.manufacturerLogoURL"/></div>
          <div class="bike-model"><span class="locale">{{bike.locale}}</span> / {{bike.bikeModel}}</div>
          <div class="bike-name">{{bike.bikeName}}</div>
          <div class="bike-year" *ngIf="bike.year && bike.year > 0">{{bike.year}}</div>
          <div class="bike-website"><a [href]="bike.websiteURL" target="_blank">Open Manufacturer URL</a></div>
          <div></div>
          <!-- <div class="image-list" *ngIf="bike.images.length > 1">
            <div *ngFor="let image of bike.images">
              <img [src]="image.mediaThumbURL" (click)="bike.primaryImageURL = image.mediaURL" />
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row cta-buttons">
      <div class="col-md-4 margin-top-8" *ngIf="bike.manufacturerRegistrationURL">
        <div class="cta-card">
          <div class="cta-content" [ngStyle]="{ 'background-image': 'url('+bike.manufacturerBackground+')' }">
            <div class="cta-overlay"></div>
            <div class="cta-image invert" [ngStyle]="{ 'background-image': 'url(' +bike.manufacturerLogoURL+ ')' }">
            </div>
          </div>
          <div class="cta-text">Register your bike with <b>{{bike.manufacturer}}</b></div>
          <div class="cta-button-container"
               (click)="openLink(bike.manufacturerRegistrationURL,'BIKE_SALE_REGISTRATION_CLICKED')">
            <div class="cta btn3">Register Your Bike</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-top-8"
           *ngIf="partner && partner.partnerID && partner.offersBookingService && partnerWidgetURL">
        <div class="cta-card">
          <div class="cta-content" style="background-image: url('/assets/bikeshop-default-background.jpg')">
            <div class="cta-overlay"></div>
            <div class="cta-image" [ngStyle]="{ 'background-image': 'url('+partner.partnerLogo+')' }">
            </div>
          </div>
          <div class="cta-text">Book your first free service with <b>{{partner.partner}}</b></div>
          <div class="cta-button-container" (click)="openLink(partnerWidgetURL,'BIKE_SALE_BOOK_SERVICE_CLICKED')">
            <div class="cta btn2">Book a Service</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 margin-top-8" *ngIf="showSundaysInsuranceAU()">
        <div class="cta-card">
          <div class="cta-content" style="background-image: url('/assets/sundays-background.jpg')">
            <div class="cta-image"
                 [ngStyle]="{ 'background-image': 'url(/assets/sundays-au-logo.png)', 'background-size': 'contain', 'margin': '16px 24px' }">
            </div>
          </div>
          <div class="cta-text">Get a quote in under 2 minutes from <b>Sundays Insurance</b></div>
          <div class="cta-button-container"
               (click)="openLink(getSundaysLink(),'BIKE_SALE_SUNDAYS_INSURANCE_AU_CLICKED')">
            <div class="cta btn1">Insure Your Bike</div>
          </div>
        </div>
      </div>
    </div>


    <div class="row" *ngIf="bike.description && bike.description.length > 50">
      <div class="col-12">
        <div class="bike-content-container">
          <h4>The Low Down On Your Bike</h4>
          <div class="bike-description" [innerHTML]="bike.description"></div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="bike.additionalContent && bike.additionalContent.length > 0">
      <div class="col-12">
        <div class="bike-extra-information bike-content-container" [innerHTML]="bike.additionalContent"></div>
      </div>
    </div>

    <div class="row" *ngIf="bike.specs && bike.specs.length > 0">
      <div class="col-12">
        <div class="bike-content-container">
          <h4>Bike Specs</h4>
          <div class="bike-specs">
            <div *ngFor="let spec of bike.specs">
              <div>{{spec.key}}:</div>
              <div>{{spec.value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="bike.tech && bike.tech.length > 0">
      <div class="col-12">
        <div class="bike-content-container">
          <h4>Bike Technology</h4>
          <div class="bike-tech">
            <div *ngFor="let tech of bike.tech">
              <div class="tech-name" *ngIf="!tech.imageURL || tech.imageURL.length === 0">{{tech.name}}</div>
              <div class="tech-image" *ngIf="tech.imageURL && tech.imageURL.length > 0">
                <img [src]="tech.imageURL"/>
                <div class="tech-image-hover" *ngIf="tech.description && tech.description.length > 0"
                     [innerHTML]="tech.description"></div>
              </div>
              <div class="tech-description" *ngIf="!tech.imageURL || tech.imageURL.length === 0"
                   [innerHTML]="tech.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="bike.videos && bike.videos.length > 0">
      <div class="col-12">
        <div class="bike-content-container">
          <h4>Videos</h4>
          <div class="bike-videos">
            <div *ngFor="let video of bike.videos">
              <!-- <img [src]="video.mediaThumbURL" />
              <a [href]="video.mediaURL" target="_blank">
                <div class="media-play"><span class="fa fa-play"></span></div>
              </a> -->
              <img [src]="video.mediaThumbURL"/>

              <!--              //todo(dcorbett) lightbox was removed-->

              <!--              <p-lightbox type="content">-->
              <!--                <a class="group" href="#">-->
              <!--                  <div class="media-play"><span class="fa fa-play"></span></div>-->
              <!--                </a>-->
              <!--                <iframe width="600" height="340" [src]="getVideoURL(video)" frameborder="0" allowfullscreen></iframe>-->
              <!--              </p-lightbox>-->
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
